// Developer     : Nicolas Pascucci
// Creation Date : 15-7-2024
// Version       : 1
// Description   :

import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Container, Tooltip, Fab, Typography } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import SaveIcon from "@mui/icons-material/Save";
import { UrlApi } from "../../../../services/apirest";
import Notify from "../../../Notify";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import GroupIcon from "@mui/icons-material/Group";
import AddLocationAltIcon from "@mui/icons-material/AddLocationAlt";
import Title from "../../../Title";
import AltaClienteEnv from "./AltaClienteEnv";
import AltaDomicilioEnv from "./AltaDomicilioEnv";
import DialogConfirmDir from "../../../referencias-tablas/clientes/abmclientes/alta/DialogConfirmDir";
import { registrarAccion, DONDE } from "../../logs/registrarAccion";

function TabAltaEnv(props) {
  const [uuid, setUuid] = useState(uuidv4());
  //Clientes:
  const [dataCliente, setDataCliente] = useState({
    razon_social: "",
    direccion_fiscal: "",
    telefono_1: "",
    telefono_2: "",
    telefono_3: "",
    mails: "",
    cuit: "",
    // id_categoria: "1",
    id_sucursal: "",
    id_localidad: "",
    id_comercial: null,
    id_condicionpago: "1",
    sisven_id: null,
    situacion_iva: null,
    usuario: "",
    activo: 1,
    // limite_credito: 0,
    id_tipocliente: "1",
    // id_provincia: "",
    uuid_cliente: uuid,
    tipo_doc_afip: 80,
    observaciones: "",
    // envase_10_kg: null,
    // envase_15_kg: null,
    // envase_45_kg: null,
    uso: null,
    factura_consfinal: 0,
    precio_especial: 0,
    entrega_con_remito: 0,
    facturar_a: null,
    facturar_a_nombre:null,
    porc_perc_iva: null,
    porc_exc_perc_iva: 0,
    vto_exc_perc_iva: null,
    id_convenio:null,
    iibb_nro_inscripcion:null,
    usuario: localStorage.getItem("user")
  });
  const [tipo, setTipo] = useState(80); //tipo=1 (cuit) || tipo=0 (dni)
  const [sitIvaSeleccionada, setSitIvaSeleccionada] = useState("");
  const [convenioSeleccionado, setConvenioSeleccionado] = useState("");
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState("");
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState("");
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState("");
  // console.log("dataCliente iibb nro", dataCliente.iibb_nro_inscripcion);
  
  //Domicilios de entrega:
  const [esDomEntrega, setEsDomEntrega] = useState(false);
  const [listaDom, setListaDom] = useState([
    {
      nro_dir: uuid,
      direccion_entrega: "",
      nombre_direccion: "",
      id_provincia: "",
      id_localidad: "",
      id_sucursal: "",
      contacto: "",
      telefono_1: "",
      telefono_2: "",
      telefono_3: "",
      mails: "",
      latitud: "",
      longitud: "",
      usuario: localStorage.getItem("user"),
      activo: 1,
      verificada: 1,
      observaciones: "",
      zona: null,
    },
  ]);
  //Estados para manejar visuales:
  const [activeTab, setActiveTab] = useState("cliente");
  const [notify, setNotify] = useState({
    open: false,
    severity: "",
    color: "",
    mensaje: "",
  });
  const icon = <WarningAmberIcon sx={{ fontSize: 40 }} />; //Icono que le paso al dialog
  const [disGuardar, setDisGuardar] = useState(true); //habilita o deshabilita el boton de guardado
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [datosFaltantes, setDatosFaltantes] = useState(); //Guarda los datos que faltan para que los formularios estén completos y se puedan guardar.

  // ---------------------FUNCIONES------------------ //
  //Añade un nuevo domicilio:
  const almacenarDomicilios = () => {
    const values = [...listaDom];
    values.push({
      nro_dir: uuid,
      direccion_entrega: "",
      nombre_direccion: "",
      id_provincia: "",
      id_localidad: "",
      id_sucursal: "",
      contacto: "",
      telefono_1: "",
      telefono_2: "",
      telefono_3: "",
      mails: "",
      latitud: "",
      longitud: "",
      usuario: localStorage.getItem("user"),
      activo: 1,
      verificada: 1,
      observaciones: "",
      zona: null,
    });
    setListaDom(values);
  };

  //Almacena los datos del domicilio que voy ingresando
  const updateItemsDom = (prop, valueOrEvent, index) => {
    const value =
      typeof valueOrEvent === "object"
        ? valueOrEvent.target.value
        : valueOrEvent;
    const old = listaDom[index];
    const updated = {
      ...old,
      [prop]: value === "" ? null : value,
    };
    const clone = [...listaDom];
    clone[index] = updated;
    setListaDom(clone);
  };

  //Actualiza las coordenadas de latitud y longitud
  const actualizarCoordenadas = (indice, lat, lng) => {
    // Crear una copia del array actual de direcciones
    const domicilios = [...listaDom];
    // Actualizar las coordenadas en el objeto JSON en el índice especificado
    domicilios[indice].latitud = lat;
    domicilios[indice].longitud = lng;
    // Actualizar el estado del array de direcciones con las nuevas coordenadas
    setListaDom(domicilios);
  };

  //Valida que existan determinados datos del cliente para que no de error al guardar.

  const validarCli = () => {
    const isListaDomValid = listaDom.every(
      (dom) => !!dom.latitud && !!dom.longitud,
    );

    const isCuitValid = dataCliente.situacion_iva === 4 || !!dataCliente.cuit;
    const isMailValid = dataCliente.situacion_iva === 4 || !!dataCliente.mails;

    // const requiereExencionValida =
    //   dataCliente.situacion_iva === 1 &&
    //   dataCliente.porc_exc_perc_iva !== null &&
    //   dataCliente.porc_exc_perc_iva !== "" &&
    //   dataCliente.vto_exc_perc_iva !== null &&
    //   dataCliente.vto_exc_perc_iva !== "";
    const requiereExencionValida =
  dataCliente.situacion_iva === 1 &&
  dataCliente.porc_exc_perc_iva !== null &&
  dataCliente.porc_exc_perc_iva !== "" &&
  (
    Number(dataCliente.porc_exc_perc_iva) <= 0 ||
    (
      dataCliente.vto_exc_perc_iva !== null &&
      dataCliente.vto_exc_perc_iva !== ""
    )
  );

    if (
      !!dataCliente.razon_social &&
      !!dataCliente.id_tipocliente &&
      !!dataCliente.situacion_iva &&
      !!dataCliente.id_condicionpago &&
      isCuitValid &&
      (!!dataCliente.telefono_1 ||
        !!dataCliente.telefono_2 ||
        !!dataCliente.telefono_3) &&
      isListaDomValid &&
      (dataCliente.situacion_iva !== 1 || requiereExencionValida)
    ) {
      setDisGuardar(false);
    } else {
      setDisGuardar(true);
    }
  };

  useEffect(() => {
    validarCli();
  }, [dataCliente, listaDom]);

  const { id_provincia, ...reqBody } = dataCliente;

  const reqBodyDir = listaDom.filter(
    (domicilio) =>
      !!domicilio.direccion_entrega &&
      !!domicilio.id_provincia &&
      !!domicilio.id_localidad,
  );

  function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleClose = () => {
    props.alta(false);
    props.tabla(true);
    props.actualiza(1);
  };

  // ---------------- FUNCIONES DE GUARDADO: -------------------- //
  const guardar = (e) => {
    e.preventDefault();
    if (
      !!listaDom[0].direccion_entrega ||
      listaDom[0].nombre_direccion ||
      listaDom[0].id_provincia ||
      listaDom[0].localidad ||
      listaDom[0].id_sucursal
    ) {
      //Hay algo en el primer domicilio de entrega, entonces vamos a analizar todo lo que haya
      const falta = listaDom
        .map((domicilio, index) => {
          const datosFaltantes = [];
          if (!domicilio.id_provincia) datosFaltantes.push("Provincia");
          if (!domicilio.id_localidad) datosFaltantes.push("Localidad");
          if (!domicilio.id_sucursal) datosFaltantes.push("Sucursal");
          if (!domicilio.direccion_entrega)
            datosFaltantes.push("Dirección de entrega");
          return {
            data: domicilio,
            index: index,
            faltaDatos: datosFaltantes.length > 0,
            datosFaltantes: datosFaltantes,
          };
        })
        .filter((elemento) => elemento.faltaDatos);
      const elementosFaltantes = falta.map((elemento) => {
        const datosFaltantesObj = { index: elemento.index };
        elemento.datosFaltantes.forEach((propiedad) => {
          datosFaltantesObj[propiedad] = true;
        });
        return datosFaltantesObj;
      });
      setDatosFaltantes(elementosFaltantes);
      if (falta.length > 0) {
        setShowConfirmDialog(true);
      } else {
        postCliDir(e, reqBody, reqBodyDir, setNotify);
      }
    } else {
      postCliDir(e, reqBody, reqBodyDir, setNotify);
    }
  };

  async function postCliDir(e, reqBody, listaDom, setNotify) {
    e.preventDefault();
    setDisGuardar(true);
 // 1. Preparar datos para crear el cliente (sin facturar_a si es 'SELF')
  const datosParaCrearCliente = { ...reqBody };
  
  // Si es facturación propia, quitamos el marcador 'SELF'
  if (datosParaCrearCliente.facturar_a === 'SELF') {
    delete datosParaCrearCliente.facturar_a;
  }
  delete datosParaCrearCliente.facturar_a_nombre;

  // 2. Crear cliente
  const resCliente = await fetch(UrlApi + "/envasado_clientes/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(datosParaCrearCliente),
  });

  if (!resCliente.ok) {
    console.log("Error creando cliente");
    return;
  }

  const dataCliente = await resCliente.json();
  const nuevoClienteId = dataCliente?.id;

  if (!nuevoClienteId) {
    console.log("No llegó ID del cliente");
    return;
  }

  registrarAccion(
    DONDE.CLIENTES,
    `Alta de cliente ${nuevoClienteId} - ${reqBody.razon_social}${reqBody.cuit ? ` (CUIT/DNI ${reqBody.cuit})` : ""}`
  );

    setNotify({ open: true, severity: "success", mensaje: "Cliente guardado" });

     if (reqBody.facturar_a === 'SELF') {
    const datosActualizacion = {
      facturar_a: nuevoClienteId, // Ahora sí tenemos el ID
      // es_facturacion_propia: true
    };
    
    await fetch(UrlApi + `/envasado_clientes/${nuevoClienteId}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(datosActualizacion)
    });
  }
    const listaConCliente = listaDom.map((d) => ({
      ...d,
      id_cliente: nuevoClienteId,
    }));

    const resDir = await fetch(
      UrlApi + "/envasado_direcciones_entrega/mapeado/",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(listaConCliente),
      },
    );

    if (!resDir.ok) {
      console.log("Error creando direcciones");
      return;
    }

    if (listaDom.length > 0) {
      registrarAccion(
        DONDE.CLIENTES,
        `Alta de ${listaDom.length} dirección(es) de entrega para cliente ${nuevoClienteId}: ${listaDom.map((d) => d.direccion_entrega).join(" | ")}`
      );
    }

    setNotify({
      open: true,
      severity: "success",
      mensaje: "Direcciones guardadas",
    });
  }

  return (
    <div style={{ zIndex: "1000" }}>
      {notify.open ? (
        <Notify
          open={notify.open}
          color={notify.color}
          severity={notify.severity}
          mensaje={notify.mensaje}
          handleClose={() => handleClose()}
        />
      ) : null}
      <Container maxWidth={false} disableGutters>
        <Title
          titulo={"Nuevo cliente"}
          handleClose={() => {
            props.alta(false);
            props.tabla(true);
            props.actualiza(0);
          }}
          pt={0}
        />
        <Box>
          <Box
            sx={{
              borderBottom: 0,
              borderColor: "divider",
              maxHeight: "50px",
            }}
          >
            <Tabs
              value={activeTab}
              onChange={(event, newValue) => setActiveTab(newValue)}
              aria-label="basic tabs example"
              centered
              variant="fullWidth"
              sx={{
                maxHeight: "50px",
              }}
            >
              <Tab
                value="cliente"
                label="cliente"
                iconPosition="end"
                icon={<GroupIcon />}
                sx={{
                  marginTop: -1,
                  maxHeight: "50px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
              <Tab
                value="domicilios"
                label="Direcciones de entrega"
                {...a11yProps(1)}
                iconPosition="end"
                icon={<AddLocationAltIcon />}
                sx={{
                  marginTop: -1,
                  maxHeight: "50px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              />
            </Tabs>

            {activeTab === "cliente" ? (
              <>
                <AltaClienteEnv
                  dataCliente={dataCliente}
                  setDataCliente={setDataCliente}
                  tipo={tipo}
                  setTipo={setTipo}
                  setListaDom={setListaDom}
                  listaDom={listaDom}
                  esDomEntrega={esDomEntrega}
                  setEsDomEntrega={setEsDomEntrega}
                  setSitIvaSeleccionada={setSitIvaSeleccionada}
                  sitIvaSeleccionada={sitIvaSeleccionada}
                  setConvenioSeleccionado={setConvenioSeleccionado}
                  convenioSeleccionado={convenioSeleccionado}
                  setProvinciaSeleccionada={setProvinciaSeleccionada}
                  provinciaSeleccionada={provinciaSeleccionada}
                  setLocalidadSeleccionada={setLocalidadSeleccionada}
                  localidadSeleccionada={localidadSeleccionada}
                  setSucursalSeleccionada={setSucursalSeleccionada}
                  sucursalSeleccionada={sucursalSeleccionada}
                  uuid={uuid}
                />
              </>
            ) : null}
            {activeTab === "domicilios" ? (
              <>
                <AltaDomicilioEnv
                  listaDom={listaDom}
                  setListaDom={setListaDom}
                  almacenarDomicilios={almacenarDomicilios}
                  handleInputChange={updateItemsDom}
                  actualizarCoordenadas={actualizarCoordenadas}
                  tipoCliente={dataCliente.id_tipocliente}
                  uuid={uuid}
                />
              </>
            ) : null}
          </Box>
        </Box>
        <Box
          sx={{
            position: "fixed",
            bottom: 16,
            right: 16,
            mb: 3,
          }}
        >
          <Tooltip title="Guardar">
            <Fab
              disabled={disGuardar}
              color="success"
              aria-label="add"
              onClick={guardar}
              sx={{ mr: 1 }}
            >
              <SaveIcon />
            </Fab>
          </Tooltip>
        </Box>
        {showConfirmDialog && (
          <DialogConfirmDir
            notify={{ open: false }}
            open={showConfirmDialog}
            setOpen={setShowConfirmDialog}
            color="red"
            icon={icon}
            title={"Datos Incompletos"}
            subtitle={
              "Algunos domicilios no cuentan con la información requerida: "
            }
            items={datosFaltantes}
            confirmText={"Por favor, complételos e intente nuevamente."}
          />
        )}
      </Container>
    </div>
  );
}

export default TabAltaEnv;
